export const DEFAULT_CURRENCY = 'INR';

export function normalizeCurrency(currency) {
  return String(currency || DEFAULT_CURRENCY).trim().toUpperCase();
}

export function getCurrencySymbol(currency = DEFAULT_CURRENCY) {
  const normalizedCurrency = normalizeCurrency(currency);
  try {
    return new Intl.NumberFormat(normalizedCurrency === 'INR' ? 'en-IN' : undefined, {
      style: 'currency',
      currency: normalizedCurrency,
    })
      .formatToParts(0)
      .find((part) => part.type === 'currency')?.value ?? normalizedCurrency;
  } catch {
    return normalizedCurrency;
  }
}

export function formatAdminPrice(value, currency = DEFAULT_CURRENCY) {
  if (value === null || value === undefined) return null;
  const normalizedCurrency = normalizeCurrency(currency);
  try {
    return new Intl.NumberFormat(normalizedCurrency === 'INR' ? 'en-IN' : undefined, {
      style: 'currency',
      currency: normalizedCurrency,
    }).format(Number(value));
  } catch {
    return Number(value).toFixed(2);
  }
}
